import React from 'react'
import Select from 'react-select'
import { useTheme } from '../../context/ThemeContext'


const SelectStatus: React.FC<any> = ({ selectedOption, setSelectedOption, role, isHome }): any => {
    const { theme: themeDark } = useTheme()

    // const [selectedOption, setSelectedOption] = useState<{ value: string; label: string } | null>(null)
    const options = [{ value: 'active', label: 'Active' }, { value: 'hidden', label: 'Hidden' }, { value: 'archived', label: 'Archived' }]
    const colourStyles: any = {
        option: (styles: any, { isFocused, isSelected }: any) => ({
            ...styles,
            backgroundColor: isHome ? isSelected
                ? '#009ef7'
                : isFocused
                    ? themeDark === 'dark' ? '#2a2a2a' : '#f0f0f0'
                    : 'transparent' : styles.backgroundColor,
            color: isSelected
                ? 'white'
                : isHome
                    ? themeDark === 'dark'
                        ? 'white'
                        : 'black'
                    : styles.color,
        }),

        control: (styles: any, state: any) => ({
            ...styles,
            backgroundColor:
                isHome
                    ? (themeDark === 'dark' ? '' : '') : (themeDark === 'dark' ? '' : 'white'),
            borderColor:
                state?.isFocused ? '#d4f746' : 'hsl(0, 0%, 80%)',
            boxShadow: (state?.isFocused ? '0 0 0 1px #d4f746' : 'none'),
            '&:hover': {
                borderColor: '#d4f746',
            },
        }),
        multiValue: (styles: any) => {
            return {
                ...styles,
                backgroundColor: themeDark === 'dark' ? '#141520' : '#E6E6E6',
                color: isHome
                    ? themeDark === 'dark' ? 'white' : 'black'
                    : styles.color
            }
        },
        indicatorSeparator: (styles: any) => ({
            ...styles,
            backgroundColor:
                isHome
                    ? ''
                    : styles.backgroundColor,
        }),
        multiValueLabel: (styles: any, { data }: any) => ({
            ...styles,
            backgroundColor: data.isDisabled ? '#FF677E' : '',
            color: data.isDisabled ? 'white' : '',
        }),
        multiValueRemove: (styles: any, { data }: any) => ({
            ...styles,
            color: data.color,
            ':hover': {
                backgroundColor: '#FF677E',
                color: 'white',
            },
        }),
        valueContainer: (styles: any) => ({
            ...styles,
            overflow: 'auto',
        }),
        dropdownIndicator: (styles: any) => ({
            ...styles,
            color: themeDark === 'dark' ? '#FF7C00' : 'hsl(0, 0%, 80%)',
        }),
        placeholder: (styles: any) => ({
            ...styles,
            color: themeDark === 'dark' ? '#98C6F0' : 'hsl(0, 0%, 80%)',
        }),
    }
    return (
        <Select
            // placeholder={options[0].label}
            isDisabled={role === 'Guest'}
            options={options}
            value={isHome ? options.find(opt => opt.value === selectedOption) : selectedOption}
            onChange={(option) => setSelectedOption(option as { value: string; label: string })}
            styles={colourStyles}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    neutral0: themeDark === 'dark' ? "rgb(57,73,89)" : theme.colors.neutral0,
                    neutral80: themeDark === 'dark' ? "#F4FFFD" : theme.colors.neutral80,
                    primary25: themeDark === 'dark' ? "#141520" : theme.colors.primary25
                },
            })}
        />
    )
}

export default SelectStatus